import React from 'react';
import { FilterChipDatePicker } from '@razorpay/blade/components';
import type { DatesRangeValue } from '@razorpay/blade/components';

import { DateFilterChipProps } from './types';
import { formatDate, getDateRangeValue, parseDate } from './utils';
import { DATE_PICKER_PORTAL_Z_INDEX } from './constants';

// Blade's FilterChipDatePicker supports zIndex for its portal but omits it from
// the public prop types — widen the type instead of using `any` at the call site.
type FilterChipDatePickerWithPortalProps = React.ComponentProps<typeof FilterChipDatePicker> & {
  zIndex?: number;
};
const FilterChipDatePickerWithPortal =
  FilterChipDatePicker as React.ComponentType<FilterChipDatePickerWithPortalProps>;

const getDateRangePickerValue = (value: DateFilterChipProps['value']): DatesRangeValue => {
  const dateRange = getDateRangeValue(value);
  return [parseDate(dateRange.startDate), parseDate(dateRange.endDate)];
};

export const DateFilterChip = ({
  definition,
  value,
  isDisabled,
  onApply,
  onClearButtonClick,
}: DateFilterChipProps) => {
  const handleApply = (dates: DatesRangeValue) => {
    const [startDate, endDate] = dates;
    onApply({
      startDate: startDate ? formatDate(startDate) : null,
      endDate: endDate ? formatDate(endDate) : null,
    });
  };

  return (
    <FilterChipDatePickerWithPortal
      label={definition.label}
      selectionType="range"
      defaultValue={getDateRangePickerValue(value)}
      isDisabled={isDisabled}
      accessibilityLabel={`${definition.label} date range`}
      name={definition.fieldKey}
      format="DD/MM/YYYY"
      inputPlaceHolder="DD/MM/YYYY"
      zIndex={DATE_PICKER_PORTAL_Z_INDEX}
      onApply={handleApply}
      onClearButtonClick={onClearButtonClick}
    />
  );
};
